<template>
  <v-input
    v-model="value"
    :rules="rules"
    class="v-input--checkbox-group"
  >
    <v-layout
      wrap
    >
      <v-flex
        v-if="label"
        :class="{ 'error--text': errorBucket.length && hasFocused }"
        class="xs12 caption"
      >{{ label }}</v-flex>
      <slot name="hint"/>
      <v-flex
        v-if="hint"
        class="xs12 caption mb-1 grey--text text--darken-1"
      >{{ hint }}</v-flex>
      <div class="cp-radio">
        <template v-for="(item, i) in items">
          <div
            :class="itemClass(i)"
            :key="`radio-${i}-${name}`"
            :style="itemStyle"
            @click.prevent="onChange(item[itemValue])"
          >{{ item[itemText] }}</div>
        </template>
      </div>
    </v-layout>
  </v-input>
</template>

<script>
import {
  VRadioGroup,
  VInput,
} from 'vuetify/lib';

export default {
  name: 'CpRadio',
  components: {
    VInput,
  },
  extends: VRadioGroup.VRadioGroup,
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    value: {
      type: [String, Number],
      default: null,
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    itemText: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      default: 'radio',
    },
    hint: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: null,
    },
    hasFocused: {
      type: Boolean,
      default: false,
    },
    errorBucket: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lazyValue: this.value,
    };
  },
  computed: {
    itemStyle() {
      return {
        width: `${100 / this.items.length}%`,
      };
    },
  },
  methods: {
    onChange(v) {
      this.$emit('change', v);
      this.lazyValue = v;
    },
    itemClass(i) {
      return {
        'cp-radio__item': true,
        'cp-radio__item--active': this.lazyValue === this.items[i][this.itemValue],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-radio {
  display: flex;
  width: 100%;

  &__item {
    display: block;
    height: 50px;
    padding: 10px;
    line-height: 30px;
    text-align: center;
    color: #5D4037;
    font-size: 14px;
    background: #FFF8E1;
    border: 1px solid #bfbfbf;
    cursor: pointer;
    transition: background .5s ease;

    &:not(:last-child) {
      border-right: 0;
    }

    &:hover {
      background: #FFECB3;
      transition: background .5s ease;
    }

    &--active,
    &--active:hover {
      background: #FFE082;
      cursor: default;
      transition: background .5s ease;
    }

    &--active {
      font-weight: bold;
    }

    &:last-child {
      border-radius: 0 2px 2px 0;
    }

    &:first-child {
      border-radius: 2px 0 0 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/CpRadio.vue